import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionAbout from 'js/containers/header-region/HeaderRegion.about';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import svg
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import
import { getSiteMetaData, getCurrentPageData } from 'js/store/app/App.selectors';

const PageAbout = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.about]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.about);
  });

  useEffect(() => {
    trackPageview({ title: 'about the show', path: props.path });
  }, []);

  const { header = {}, body = {} } = pageData;

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionAbout
        title={header?.title || ''}
        description={header?.description || ''}
        image={header?.image || ''}
      />
      <div className="about-page">
        <SvgTextureLineLong color={'#1a8175'} />
        <div className="container">
          <div className="about-page__body wysiwyg">
            {(body?.description || '') !== '' && <div dangerouslySetInnerHTML={{ __html: body.description }} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageAbout;
